import { Grid, Typography, useTheme, Box } from "@mui/material";
import { capitalize } from "lodash";
import { useTranslation } from "react-i18next";
import { memo } from "react";
import { width } from "@mui/system";

const ProjectListTableHeader = (props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const headerStyle = {
    backgroundColor: theme.palette.mode === "dark" ? "#121212" : "#fff",
    borderBottom: `2px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`,
    borderRadius: "8px 8px 0 0",
    width: "100%",
  };

  const textStyle = {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.mode === "dark" ? "#FFFFFF" : "#333333",
    textTransform: "uppercase" as const,
    letterSpacing: "0.5px",
  };

  return (
    <Box
      sx={{
        // No separate left/right margin any more — the header now shares the
        // Grid with padding "0px 16px" with ProjectList (Home.tsx) so that the
        // 56 columns here line up exactly with the 56 columns of each project
        // row below.
        margin: "0 0 8px 0",
        ...headerStyle,
      }}
    >
      <Grid
        container
        columns={56}
        sx={{
          padding: "12px 4px",
          alignItems: "center",
          minHeight: 56,
        }}
      >
        {/* Thumbnail space */}
        <Grid item xs={8}>
          <Box sx={{ width: 40 }} />
        </Grid>

        {/* Project Name */}
        <Grid item xs={11}>
          <Typography
            sx={{ ...textStyle, textAlign: "left", paddingLeft: "10px" }}
          >
            {capitalize(t("NAME"))}
          </Typography>
        </Grid>

        {/* Jobsite */}
        <Grid item xs={8}>
          <Typography sx={{ ...textStyle, textAlign: "center" }}>
            {capitalize(t("JOBSITE_NAME_HEADER"))}
          </Typography>
        </Grid>

        {/* Photographer */}
        <Grid item xs={6}>
          <Typography sx={{ ...textStyle, textAlign: "center" }}>
            {t("PHOTOGRAPHER")}
          </Typography>
        </Grid>

        {/* Type */}
        <Grid item xs={3}>
          <Typography sx={{ ...textStyle, textAlign: "center" }}>
            {t("TYPE")}
          </Typography>
        </Grid>

        {/* Date */}
        <Grid item xs={7}>
          <Typography sx={{ ...textStyle, textAlign: "center" }}>
            {/* {t("DATE_TAKEN")} */}
            {props.sortBy === "upload" ? t("UPLOAD_DATE") : t("CAPTURED_DATE")}
          </Typography>
        </Grid>

        {/* Number of image */}
        <Grid item xs={4}>
          <Typography sx={{ ...textStyle, textAlign: "center" }}>
            {t("IMAGE_NUMBER")}
          </Typography>
        </Grid>

        {/* Status */}
        <Grid item xs={8}>
          <Typography sx={{ ...textStyle, textAlign: "left" }}>
            {t("STATUS")}
          </Typography>
        </Grid>

        {/* Actions space */}
        <Grid item xs={1}>
          <Box sx={{ width: 24 }} />
        </Grid>
      </Grid>
    </Box>
  );
};
export default memo(ProjectListTableHeader);
